import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found</title>
      </Helmet>

      <div className="container section" style={{ textAlign: 'center', padding: '5rem 1rem' }}>
        <h1 style={{ fontSize: '6rem', color: 'var(--primary-color)' }}>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you're looking for doesn't exist.</p>
        <Link to="/" className="btn btn-primary btn-lg" style={{ marginTop: '2rem' }}>
          Go Home
        </Link>
      </div>
    </>
  );
};

export default NotFound;
